import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

import SignIn from "./Signin";
import CreateAccount from "./CreateAccount";
import SubmitAnswers from "./SubmitAnswers";
import Compare from "./Compare";
import { Paths } from "./constants";

import "./App.css";

const router = createBrowserRouter([
  {
    path: Paths.CREATE_ACCOUNT,
    element: <CreateAccount />,
  },
  {
    path: Paths.SIGN_IN,
    element: <SignIn />,
  },
  {
    path: Paths.SUBMIT_ANSWERS,
    element: <SubmitAnswers />,
  },
  {
    path: Paths.COMPARE,
    element: <Compare />,
  },
  {
    path: "*",
    element: <Navigate to={Paths.CREATE_ACCOUNT} replace />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
